import { LeftOutlined } from '@ant-design/icons';
import { Card } from '@app/components/common/Card/Card';
import { notificationController } from '@app/controllers/notificationController';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import * as S from './../worker/WorkerLayout.styles';
import { ClientInfo } from './ClientCard/ClientInfo/ClientInfo';
import { ClientNav } from './ClientCard/ClientNav/ClientNav';
import { setClient } from '@app/store/slices/clientSlice';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import { getClient } from '@app/api/client.api';

const ClientLayout: React.FC = () => {
  const client = useAppSelector((state) => state.client.client);
  const { id } = useParams<{ id: string }>();

  const dispatch = useAppDispatch();

  const getTitle = () => {
    return id ? t(`clients.form.updateTitle`) : t(`clients.form.addTitle`);
  };

  const { t } = useTranslation();
  const { isTablet: isTabletOrHigher, mobileOnly } = useResponsive();
  const navigate = useNavigate();

  const isTitleShown = isTabletOrHigher || (mobileOnly && location.pathname === `${ADMIN_BASE_BATH}/clients`);

  useEffect(() => {
    async function fetchClient() {
      if (id) {
        try {
          const client = await getClient(id);
          dispatch(setClient(client));
        } catch (error) {
          notificationController.error({ message: (error as Error).message });
        }
      }
    }

    fetchClient();

    return () => {
      dispatch(setClient(null));
    };
  }, [dispatch, id]);

  return (
    <>
      {!isTitleShown && (
        <S.Btn icon={<LeftOutlined />} type="text" onClick={() => navigate(`${ADMIN_BASE_BATH}/clients`)}>
          {t('common.back')}
        </S.Btn>
      )}
      <Card title={getTitle()} padding="1.25rem">
        <Row gutter={[30, 30]}>
          <Col xs={24} md={24} xl={8}>
            <S.ProfileCard>
              <Row gutter={[30, 30]}>
                <Col xs={24} md={12} xl={24}>
                  <ClientInfo client={client} />
                </Col>

                <Col xs={24} md={12} xl={24}>
                  <ClientNav />
                </Col>
              </Row>
            </S.ProfileCard>
          </Col>
          <Col xs={24} md={24} xl={16}>
            <Outlet />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ClientLayout;
